import React from 'react';
import { connect } from 'react-redux';
import * as routes from 'app/routes';
import add_card_icon from './add_card_icon.svg';
import styles from './index.module.css';
import NewCard from 'billing/paymentMethods/NewCard';
import Back from 'common/Back';
import Warning from 'notifications/Warning';

import { billing } from 'app/routes';

export const AddCard = ({ billingNav }) => (
  <div>
    <Back to={billing()} />
    <h1>
      Add Card
      <img className={styles.headerImg} src={add_card_icon} alt="" />
    </h1>
    <NewCard onSubmitSuccess={billingNav} />
    <Warning name="newCard" />
  </div>
);

const mapDispatchToProps = {
  billingNav: routes.billing
}

export default connect(
  null,
  mapDispatchToProps
)(AddCard);
